// Frontend-only package catalog — the `packages` backend table has no concept of "people" or
// per-person session splits, so this list (name/price/session breakdown) is the single source
// of truth for what the Assign Package flow displays and lets an admin pick, independent of
// whatever rows actually exist in the database. `matchServiceQty` is the *first* member's
// session count (Član 1's slot — the package's own `service_qty` in the backend), used by
// PackageAssignFlow.jsx's `displayPackages` to resolve a real backend package: for a
// single-vežbač entry that's just a parent package with no children; for a multi-vežbač entry
// it's a parent package whose children (added via the Admin App's "packages with children"
// feature) collectively match `sessionsPerPerson.slice(1)`. Every entry below now has a real
// backend counterpart (kept in sync with the Admin App's package setup — the source of truth
// for names/prices/session counts/member counts).
export const PACKAGE_CATALOG = [
  // Matched by name (isTrialLike), not service_qty — a real "Besplatna proba" package shares
  // service_qty=1 with "Pojedinačni trening" below but is a distinct DB row, so `isTrial: true`
  // tells the matcher to look it up by name instead of colliding with the single-session match.
  {
    key: "trial",
    name: "Besplatna proba",
    people: 1,
    sessionsPerPerson: [1],
    price: 0,
    matchServiceQty: null,
    isTrial: true,
    featured: false,
  },
  {
    key: "single",
    name: "Pojedinačni trening",
    people: 1,
    sessionsPerPerson: [1],
    price: 1200,
    matchServiceQty: 1,
    featured: false,
  },
  {
    key: "p1-8",
    name: "1 Vežbač · 8 termina",
    people: 1,
    sessionsPerPerson: [8],
    price: 6000,
    matchServiceQty: 8,
    featured: false,
  },
  {
    key: "p1-12",
    name: "1 Vežbač · 12 termina",
    people: 1,
    sessionsPerPerson: [12],
    price: 7500,
    matchServiceQty: 12,
    featured: true,
  },
  {
    key: "p2-8-8",
    name: "2 Vežbača · 8 + 8",
    people: 2,
    sessionsPerPerson: [8, 8],
    price: 11000,
    matchServiceQty: 8,
    featured: false,
  },
  {
    key: "p2-12-8",
    name: "2 Vežbača · 12 + 8",
    people: 2,
    sessionsPerPerson: [12, 8],
    price: 12000,
    matchServiceQty: 12,
    featured: false,
  },
  {
    key: "p2-12-12",
    name: "2 Vežbača · 12 + 12",
    people: 2,
    sessionsPerPerson: [12, 12],
    price: 12500,
    matchServiceQty: 12,
    featured: false,
  },
  {
    key: "p3-8-8-8",
    name: "3 Vežbača · 8 svaki",
    people: 3,
    sessionsPerPerson: [8, 8, 8],
    price: 16000,
    matchServiceQty: 8,
    featured: false,
  },
  {
    key: "p3-12-12-12",
    name: "3 Vežbača · 12 svaki",
    people: 3,
    sessionsPerPerson: [12, 12, 12],
    price: 18000,
    matchServiceQty: 12,
    featured: false,
  },
];

export const totalSessions = (entry) =>
  entry.sessionsPerPerson.reduce((sum, n) => sum + n, 0);

export const sessionsLabel = (entry) => entry.sessionsPerPerson.join(" + ");
